import React from 'react';

const BREAKPOINT = 760;
export default function useIsMobile(breakpoint = BREAKPOINT): boolean {
    const query = `(max-width: ${breakpoint}px)`;
    const [isMobile, setIsMobile] = React.useState(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return false;
        return window.matchMedia(query).matches;
    });

    React.useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) {
            return undefined;
        }
        const mql = window.matchMedia(query);
        const onChange = (): void => setIsMobile(mql.matches);
        onChange();
        mql.addEventListener('change', onChange);
        return () => mql.removeEventListener('change', onChange);
    }, [query]);

    return isMobile;
}
